import { Flexbox, FlexboxVertical } from '../../styles/Layouts';
import styled from 'styled-components';
import { FC } from 'react';
import { BoxedContent, BREAKPOINT_MD } from '../../styles/General';
import { getUIComponentProps, UIComponentProps } from '../../styles/UIComponentProps';
import { getTheme, ThemeColorKey } from '../../styles/Theme';

const Wrapper = styled(Flexbox).attrs({ as: 'section' })<{ background: string }>`
  align-items: flex-start;
  flex: 1;
  background: ${({ background }) => getTheme(({ colors }) => colors[background as ThemeColorKey] || background)};
  z-index: 1;
  
  &:last-child {
    padding-bottom: 3.5rem;
  }
`;

export const BoxedContentWrapper = styled(FlexboxVertical)<{ row?: boolean, center?: boolean }>`
  ${BoxedContent};
  align-items: ${({ center }) => center ? 'center' : ''};

  padding: 0 1.5rem;

  ${BREAKPOINT_MD} {
    padding: 0 3rem;
  }
`;

interface Props {
  background?: ThemeColorKey | string,
  row?: boolean,
  center?: boolean,
}

export const SectionWrapper: FC<Props & UIComponentProps> = (props) => {
  const {
    children,
    background = '',
    row,
    center,
  } = props;

  return (
    <Wrapper {...getUIComponentProps(props)} background={background}>
      <BoxedContentWrapper row={row} center={center}>
        {children}
      </BoxedContentWrapper>
    </Wrapper>
  );
};